var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64571 2.85157L0.942759 10.5551C0.903971 10.594 0.876326 10.6426 0.86271 10.6958L0.00888217 14.1228C-0.00367547 14.1737 -0.0029059 14.2269 0.0111166 14.2774C0.025139 14.3278 0.0519404 14.3738 0.088932 14.4109C0.145751 14.4676 0.222681 14.4994 0.302901 14.4994C0.327647 14.4994 0.352299 14.4964 0.376299 14.4904L3.80329 13.6364C3.85658 13.623 3.90522 13.5954 3.944 13.5565L11.6477 5.85347L8.64571 2.85157ZM13.556 1.8012L12.6985 0.94376C12.1255 0.370676 11.1266 0.371244 10.5542 0.94376L9.50386 1.99413L12.5057 4.99592L13.556 3.94557C13.8423 3.65943 14 3.27854 14 2.87346C14 2.46837 13.8423 2.08748 13.556 1.8012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditIcon);
export default __webpack_public_path__ + "static/media/profile-edit-icon.d7d7bdd5ef66694fdc24ee29cd702bee.svg";
export { ForwardRef as ReactComponent };